import { TRANSACTION_PRODUCT, TRANSACTION_STATUS, createTransactionPage } from '@vezeeta/vpay-pack';

const valueOrFallback = (value, fallback) => value ?? fallback;

export const TRANSACTIONS_PAGE_SIZE = 10;
export const TRANSACTIONS_DESKTOP_MIN_WIDTH = 768;

export const createTransactionsRequestError = () => {
  const error = new Error('Unable to load transactions');
  error.retryable = true;
  return error;
};

export const mapTransactionDto = (dto, formatDate) => ({
  id: dto?.transactionKey,
  sourceName: dto?.fromAccountName,
  destinationName: dto?.toAccountName,
  productId: dto?.paymentProductId,
  directionId: dto?.transactionDirectionId,
  viewId: dto?.transactionViewId,
  statusId: dto?.transactionStatusId,
  amount: dto?.amount,
  currency: dto?.currency,
  occurredAt: dto?.timestamp,
  occurredAtLabel: formatDate ? formatDate(dto?.timestamp) : dto?.timestamp,
});

export const mapTransactionsPage = (response, formatDate) => {
  if (!response?.isSuccess) {
    throw createTransactionsRequestError();
  }

  const data = response.data || {};
  return createTransactionPage({
    page: data.page,
    pageSize: data.pageSize || TRANSACTIONS_PAGE_SIZE,
    transactions: Array.isArray(data.transactions)
      ? data.transactions.map(dto => mapTransactionDto(dto, formatDate))
      : [],
  });
};

export const mapTransactionContent = localization => {
  const table = localization?.transactionsTable || {};
  return {
    sender: table.sender,
    branchName: table.branchName,
    serviceType: table.serviceType,
    payment: table.payment,
    allStatus: table.allStatus,
    fromPrefix: valueOrFallback(table.from, 'From '),
    loading: valueOrFallback(localization?.loading, 'Loading'),
    error: valueOrFallback(localization?.error, 'Unable to load transactions'),
    retry: valueOrFallback(localization?.retry, 'Retry'),
    unknownProduct: valueOrFallback(table.unknown, 'Unknown'),
    unknownStatus: valueOrFallback(table.unknown, 'Unknown'),
    products: {
      [TRANSACTION_PRODUCT.TELEHEALTH]: table.telehealth,
      [TRANSACTION_PRODUCT.EPHARMACY]: table.epharmacy,
      [TRANSACTION_PRODUCT.MOTOCHANNEL]: table.motochannel,
      [TRANSACTION_PRODUCT.SUBSCRIPTION]: table.subscription,
      [TRANSACTION_PRODUCT.CLINIC_VISITS]: table.clinicvisits,
      [TRANSACTION_PRODUCT.LABS_PROVIDERS]: table.labsproviders,
      [TRANSACTION_PRODUCT.LABS_HOME_SAMPLING]: table.labshomesampling,
      [TRANSACTION_PRODUCT.SCANS]: table.scans,
      [TRANSACTION_PRODUCT.INCLINIC_SERVICES]: table.inclinicservices,
      [TRANSACTION_PRODUCT.SURGICAL_OPERATIONS]: table.surgicaloperations,
      [TRANSACTION_PRODUCT.OFFERS]: table.offers,
    },
    statuses: {
      [TRANSACTION_STATUS.PENDING]: table.pending,
      [TRANSACTION_STATUS.COMPLETED]: table.completed,
      [TRANSACTION_STATUS.FAILED]: table.failed,
      [TRANSACTION_STATUS.ON_HOLD]: table.onhold,
      [TRANSACTION_STATUS.UNKNOWN]: valueOrFallback(table.unknown, 'Unknown'),
    },
    empty: localization?.noPayments,
  };
};

export const getTransactionsLayout = width =>
  width > TRANSACTIONS_DESKTOP_MIN_WIDTH ? 'desktop' : 'mobile';
